
<template>
    <v-tooltip text="Download Bulk Template" location="bottom">
        <template #activator="{ props }">
            <!-- <v-icon  v-bind="props" start @click="downloadExcel"> mdi-file-document-outline</v-icon> -->
             <v-btn
                v-bind="props"
                variant="outlined"
                class="rounded-lg bulk"
                @click="downloadExcel"
            >
                <v-icon start>mdi-file-document-outline</v-icon>
                Download Template
            </v-btn>
        </template>
    </v-tooltip>
</template>
  
  <script>
  import * as XLSX from "xlsx";
  
  export default {
    props: {
    data: {
        type: Array,
        required: true, 
        },
    text: {
        type: String,
        required: true
    }
    },
    methods: {
      downloadExcel() {
      const workbook = XLSX.utils.book_new();

      this.data.forEach((sheet) => {
        const headers = [sheet.data]; 
        const worksheet = XLSX.utils.aoa_to_sheet(headers);

        XLSX.utils.book_append_sheet(workbook, worksheet, sheet.name || "Sheet");
      });

      XLSX.writeFile(workbook, `${this.text}Template.xlsx`);
      },
    },
  };
  </script>
  <style>
  .bulk{
    background-color: #082fb1;
    color: #fff;
  }
</style>
  